import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { RequestServiceService } from 'src/app/core/services/request-service/request-service.service';

declare const $: any;
declare interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}
export const ROUTES: RouteInfo[] = [
    { path: '/dashboard', title: 'Dashboard',  icon: 'dashboard', class: '' },
    { path: '/outlet-manager', title: 'Outlet Management',  icon: 'person', class: '' },
    { path: '/order-manager', title: 'Order Manager',  icon: 'shopping_cart', class: '' },
    { path: '/product-manager', title: 'Product Manager',  icon: 'category', class: '' },
    { path: '/outlet-owner-manager', title: 'Outlet Owner Manager',  icon: 'supervisor_account', class: '' },
    { path: '/payment-manager', title: 'Payment Manager',  icon: 'payment', class: '' },
    { path: '/transactions-manager', title: 'Transactions Manager',  icon: 'receipt_long', class: '' },
    { path: '/coupons-manager', title: 'Coupons Manager',  icon: 'save_alt', class: '' },
    // { path: '/project-manager', title: 'Project Manager',  icon: 'person', class: '' },
    // { path: '/product-category-manager', title: 'Product Category Manager',  icon: 'assignment', class: '' },
    // { path: '/reports-manager', title: 'Reports Manager',  icon: 'dashboard', class: '' },


    // { path: '/user-profile', title: 'User Profile',  icon:'person', class: '' },
    // { path: '/table-list', title: 'Table List',  icon:'content_paste', class: '' },
    // { path: '/typography', title: 'Typography',  icon:'library_books', class: '' },
    // { path: '/icons', title: 'Icons',  icon:'bubble_chart', class: '' },
    // { path: '/maps', title: 'Maps',  icon:'location_on', class: '' },
    // { path: '/notifications', title: 'Notifications',  icon:'notifications', class: '' },
    // { path: '/upgrade', title: 'Upgrade to PRO',  icon:'unarchive', class: 'active-pro' },
];

export const ROUTES2: RouteInfo[] = [
  { path: '/dashboard', title: 'Dashboard',  icon: 'dashboard', class: '' },
  { path: '/order-manager', title: 'Order Manager',  icon: 'shopping_cart', class: '' },
  { path: '/payment-manager', title: 'Payment Manager',  icon: 'payment', class: '' },
  { path: '/transactions-manager', title: 'Transactions Manager',  icon: 'receipt_long', class: '' },
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  @Input('isExpanded') isExpanded: any = false

  menuItems: any=[];
  menuItems2: any=[];
 

  id:any="";
  isRestaurantInfoSubmitted: any=false;
  toggleSidebar() {
    this.isExpanded = !this.isExpanded;
  }
  
  constructor( private cdr: ChangeDetectorRef,private requestApiService:RequestServiceService) { 
    this.id=localStorage.getItem('res_uid')?localStorage.getItem('res_uid'):"";
    this.requestApiService.isRestaurantInfoSubmitted$.subscribe((isSubmitted) => {
      this.isRestaurantInfoSubmitted = isSubmitted;
    });
  }
  isSubMenuVisible: boolean = false;

  toggleCollapse() {
    this.isSubMenuVisible = !this.isSubMenuVisible;
  }
  ngOnInit() {
    this.cdr.detectChanges();
   
    this.menuItems = ROUTES.filter(menuItem => menuItem);
    this.menuItems2 = ROUTES2.filter(menuItem => menuItem);
  }
  isMobileMenu() {
      if ($(window).width() > 991) {
          return false;
      }
      return true;
  };
}
export class SidenavAutosizeExample {
  showFiller = false;
}